import React from 'react';
import InstitutionDashboardComponent from '../../components/Dashboard/InstitutionDashboardComponent';

const InstitutionDashboardPage = () => {
  return (
    <div>
      <InstitutionDashboardComponent />
    </div>
  );
};

export default InstitutionDashboardPage;
